import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../commonInfra/utils/ImgUrl';
import { InteractiveModalDialog } from '../styles/StarterStyles';

export interface StartersModalCloseButtonProps {
  handleClick: () => void;
  tooltipText: string;
}

const getCloseButtonContent = (): JSX.Element => {
  return (
    <div className={InteractiveModalDialog.CloseButton}>
      <div style={{display: 'inline-flex'}}>
        <img
          src={imgPath('dialogs_close_active.svg')}
          draggable={false}
          alt={Messages.acceleratorsCloseButtonAltText()}
          style={{width: '100%', height: '100%'}}
        />
      </div>
    </div>
  );
};

export class StartersModalCloseButton extends React.PureComponent<StartersModalCloseButtonProps> {

  render() {
    return (
      <div className={InteractiveModalDialog.CloseButtonContainer}>
        <Tooltip
          afterDelay
          position={TooltipPosition.Right}
          testId={'starters-modal-close-tooltip'}
          tooltipContent={this.props.tooltipText}
        >
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            handleClick={this.props.handleClick}
            testId={'starters-modal-close'}
            getContent={getCloseButtonContent}
          />
        </Tooltip>
      </div>
    );
  }
}
